export default "__VITE_ASSET__Brn6mrq8__"